import { AnyAction, applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk, { ThunkAction } from 'redux-thunk'
import { TypedUseSelectorHook, useDispatch, useSelector } from '@gsc/preact-redux'
import { IWidgetRuntime } from '../../interfaces'
import widgetsReducer from './widgets'
import templateTagsReducer from './templateTags'
import globalSettingsReducer from './globalSettings'

const composeEnhancers: typeof compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const configureStore = (runtime: IWidgetRuntime) => {
  return createStore(
    combineReducers({
      widgets: widgetsReducer,
      templateTags: templateTagsReducer,
      globalSettings: globalSettingsReducer,
    }),
    composeEnhancers(applyMiddleware(thunk.withExtraArgument(runtime))),
  )
}

export type Store = ReturnType<typeof configureStore>

export type AppDispatch = Store['dispatch']
export type RootState = ReturnType<Store['getState']>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, IWidgetRuntime, AnyAction>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
